function format(hex: string, opacity?: number): string {
  const aRgbHex = hex.replace('#', '').match(/.{1,2}/g);
  const rgb = [
    parseInt(aRgbHex[0], 16),
    parseInt(aRgbHex[1], 16),
    parseInt(aRgbHex[2], 16),
  ];

  if (opacity) {
    rgb.push(opacity);
  }

  return `(${rgb.join(',')})`;
}

export function hexToRgba(hex: string, opacity: number): string {
  const rgba = format(hex, opacity);
  return `rgba`.concat(rgba);
}
